import 'core-js/stable';

import("@/plugins/datadog-browser-logs")

import { createApp } from 'vue'
import { createPinia } from "pinia";
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from './App.vue'
import router from './router'
import store from './store'

import EmptyLayout from '@/components/layout/EmptyLayout.vue'
import FrontLayout from '@/components/layout/FrontLayout.vue'
import FrontEmptyLayout from '@/components/layout/FrontEmptyLayout.vue';
import DefaultLayout from '@/components/layout/DefaultLayout.vue'
import SideServiceLayout from '@/components/layout/SideServiceLayout.vue'

import { initGaGtag } from '@/plugins/ga-gtag'
import { initVueDragscroll } from '@/plugins/vue-dragscroll'
import VueCookies from "vue-cookies";

// init db schema
import { idb }  from '@/idb/idb'
idb.initializeDb()

import("@/plugins/moment")
import { initRouterEventHandler } from "@/plugins/router"
initRouterEventHandler(router)

import("@/plugins/worker-loader")
import("@/plugins/photo-key-seq")
import("@/plugins/yup")

const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate);
app.config.globalProperties.window = window
app.use(pinia);
app.use(router)
app.use(store)
initGaGtag()
initVueDragscroll(app)
app.use(VueCookies);

app.component('empty-layout', EmptyLayout)
app.component('front-layout', FrontLayout)
app.component('front-empty-layout', FrontEmptyLayout)
app.component('default-layout', DefaultLayout)
app.component('sideservice-layout', SideServiceLayout)

app.mount('#app')
